module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Store"
    }
  }, [(_vm.resuouce) ? _c('iframe', {
    attrs: {
      "id": "iframe",
      "src": _vm.resuouce
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-933c8e94"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/Store.vue
// module id = 239
// module chunks = 0